module.exports = __webpack_public_path__ + "img/Merkur_White.e353aace.svg";